import { useEffect, useState, useRef } from 'react';
import { stageMap } from '@/utils/contants/caseSimulation';
import { handleTaskStatus, handleRegenerate } from '@/api/grt/simulation';
import Toast from '@/components/Toast';
import { getSearchStr } from '@/utils/Page';
import { getEnvironment } from '@/utils/Mobile';
const completeStatus = [stageMap.answering, stageMap.completed, stageMap.diagnosis, stageMap.event_result_generate];
const getStatus = (stage) => {
    //进行中
    if (!stage) {
        return 1;
    }
    //已完成
    if (completeStatus.includes(stage)) {
        return 2;
    }
    //失败
    if (stage === stageMap.failed) {
        return 0;
    }
    return 1;
};
const useAiCard = (props) => {
    let { sessionStore, chatStore } = props.store;
    const { currentSessionMapId, getCurSessionMsgs } = sessionStore;
    const { handleMessages, changeSessionMapItem } = chatStore;
    let { params, side = 'web' } = props;
    let { agentId } = params;
    let { card_result = {}, getBaseParams } = props;
    const timerRef = useRef(null);
    const [cardData, setCardData] = useState({});
    const [status, setStatus] = useState();

    //修改数据，主要是为了发送消息的时候判断流程是否结束，是否可以发送消息
    //需要把currentSessionId传过来 避免切换会话时会话id已经改变 但是请求结果正好回来 导致数据错乱
    //在chat页面通过给bubbleList样式(display: none)，来渲染卡片样式，因为数据层面是闭包，导致卡片出现的时候数据始终是初始数据，每次都会触发轮询
    const changeData = (data, currentSessionId = currentSessionMapId) => {
        let msgs = getCurSessionMsgs();
        let len = msgs.length;
        let card_result = {
            ...cardData,
            ...data
        };
        console.log(card_result, 'changeData');
        if (len) {
            msgs[len - 1].card_result = msgs[len - 1].card_result || {};
        }
        console.log('msgs', msgs);
        setCardData(card_result);
        let temStatus = getStatus(card_result?.stage);
        setStatus(temStatus);
        if (temStatus === 2) {
            stopTimer();
        }
        let pageMsgs = handleMessages(msgs);
        changeSessionMapItem(
            currentSessionId,
            {
                messages: pageMsgs
            },
            msgs
        );
    };
    const getTaskStatus = async () => {
        let res = await handleTaskStatus(card_result?.runtime_session_id || card_result.component?.runtime_session_id);
        if (res && res.success) {
            changeData(res.data);
        } else {
            stopTimer();
            setStatus(0);
        }
    };
    const handeResultChange = () => {
        //如果正在轮询查询结果，则返回
        //如果不返回，temStatus还是1，导致再次发送卡片时，card_result还是上次生成的数据
        if (timerRef.current) {
            return false;
        }
        //card_result改变就会触发 ，如果卡片的状态(cardData)是已完成，就直接返回，不需要再从message去获取数据了
        //卡片的结果是轮询生成的 ，没有改变外层message数据
        // 导致再次发送卡片时，card_result还是上次生成的数据
        // 如果卡片的数据已经是生成成功了，就不用再从message去获取了，直接用缓存的数据
        //卡片的结果是轮询生成的 ，没有改变message数据，导致再次发送卡片时，card_result还是上次生成的数据，在这做个缓存
        let temStatus = getStatus(cardData?.stage);

        if (temStatus === 2) {
            console.log('temStatus', cardData);
            return;
        }
        let resultStatus = getStatus(card_result?.stage);
        if (resultStatus === 2 && card_result.batch) {
            setStatus(1);
            setCardData({
                ...card_result
                // batch: false
            });
            setTimeout(() => {
                setStatus(2);
            }, 8000);
            return;
        }
        console.log('触发了', resultStatus);
        setStatus(resultStatus);
        setCardData(card_result);
    };
    useEffect(() => {
        handeResultChange();
    }, [card_result]);
    const startTimer = () => {
        if (timerRef.current) {
            return false;
        }
        timerRef.current = setInterval(() => {
            getTaskStatus();
        }, 5000);
    };
    const stopTimer = () => {
        if (timerRef.current) {
            clearInterval(timerRef.current);
            timerRef.current = null;
        }
    };
    useEffect(() => {
        if (status === 1) {
            if (!card_result?.batch) {
                startTimer();
            }
        } else {
            stopTimer();
        }
    }, [status]);

    const goCaseSimulation = () => {
        let env = getEnvironment();

        if (status !== 2) {
            return;
        }
        let searchStr = getSearchStr();
        let sceneId = card_result?.component?.id;
        let caseId = card_result?.runtime_session_id || card_result?.component?.runtime_session_id;
        if (env === 'pc') {
            window.top.open(`/agent/web/o/${agentId}/simulation/${caseId}/${sceneId}/background${searchStr}`);
            return;
        }
        if (side === 'web') {
            window.open(`/agent/${side}/o/${agentId}/simulation/${caseId}/${sceneId}/background${searchStr}`);
        } else {
            window.location.replace(`/agent/${side}/o/${agentId}/simulation/${caseId}/${sceneId}/background${searchStr}`);
        }
    };
    useEffect(() => {
        return () => {
            stopTimer();
        };
    }, []);
    const reGenerate = async (e) => {
        let baseParasms = getBaseParams();
        let { component = {} } = card_result;
        e.stopPropagation();
        let data = {
            ...baseParasms,
            content_type: 'card',
            question: '',
            component: {
                id: component?.id,
                title: component?.title || '',
                describe: component?.describe || ''
            },
            stream: false
        };

        let res = await handleRegenerate(data);
        if (res && res.success) {
            let temData = {
                component: {
                    ...data?.component,
                    runtime_session_id: res.data?.runtime_session_id
                },
                ...res?.data,
                stage: null
            };
            changeData(temData);
        } else {
            Toast.error('重新生成失败');
        }
    };
    return {
        cardData,
        status,
        goCaseSimulation,
        reGenerate
    };
};
export default useAiCard;
